export { configureApi, getApiBase, getApiPublicBase, createApiClient, apiClient, AUTH_UNAUTHORIZED_EVENT } from "./client";
export type { Auth, ApiClient, ApiClientOptions, RequestOptions, Clock } from "./client";
export type { PaginatedResponse } from "./types";
export { decodePaginated, fetchAllPages } from "./pagination";

export { auth } from "./auth";
export { dashboard } from "./dashboard";
export type { DashboardStats, ContributionStats, TopContributor } from "./dashboard";

export { cities } from "./cities";
export type { City } from "./cities";

export { agencies } from "./agencies";
export type { Agency } from "./agencies";

export { users } from "./users";
export type { User } from "./users";

export { stops, moderation as stopModeration } from "./stops";
export type { Stop, StopPicture, StopReview } from "./stops";

export { routes, auditLogs } from "./routes";
export type { RouteData, RouteStop, RouteDetailResponse, RoutePattern, PatternStop, AuditLog } from "./routes";
export { routeSegments } from "./routes/segments";
export type { RouteSegment } from "./routes/segments";
export { snapPath } from "./routes/snap";
export type { SnapPathResult } from "./routes/snap";
export { neighborhoods } from "./neighborhoods";
export type { Neighborhood } from "./neighborhoods";
export { moderation as routeModeration } from "./moderation";
export type { RouteReview } from "./moderation";

export { fares, contributions } from "./fares";
export type { Fare, FareReport, StationSuggestion } from "./fares";

export { events } from "./events";
export type { AdminEvent, EventPicture, ContactInfo } from "./events";

export { pipeline, getOSMJob } from "./pipeline";
export type {
  FeedSummary,
  PreviewData,
  StopPreview,
  RoutePreview,
  FarePreview,
  PipelineUpload,
  UploadResponse,
  CommitResponse,
  PipelineBuild,
  PipelineManifest,
  StopConflict,
  RouteConflict,
  ConflictSummary,
  ConflictAction,
  OSMStatus,
  OSMJob,
  RoadPackStatus,
  RoadPackJob,
  CommitOverrides,
  StopOverride,
  RouteOverride,
  FareOverride,
  AgencyOverride,
  StopMerge,
  CleanupPreview,
  UploadShapeQARun,
  UploadShapeQAFlag,
  UploadShapeQAResponse,
} from "./pipeline";

export { scrapers } from "./scrapers";
export type { Scraper } from "./scrapers";

export { logs } from "./logs";
export type { LogKind, LogEntry, LogsResponse, LogsParams } from "./logs";

export { live } from "./live";
export type { SnapStopResult, MapMatchShapeResult, CheckShapeQualityResult, ShapeQaFlag,
  SnapToRoadResult, RoutePreviewResult,
  MergeGroup, MergeStopsPreviewResponse, MergeStopsApplyItem, MergeStopsApplyRequest, MergeStopsApplyResponse,
  ShapeIssue, StopProximityIssue, ShapeVerificationResult, VerifyShapesPreviewResponse,
  ShapeFixItem, VerifyShapesApplyRequest, VerifyShapesApplyResponse } from "./live";

import { auth } from "./auth";
import { dashboard } from "./dashboard";
import { cities } from "./cities";
import { agencies } from "./agencies";
import { users } from "./users";
import { stops, moderation as stopModeration } from "./stops";
import { routes, auditLogs } from "./routes";
import { routeSegments } from "./routes/segments";
import { snapPath } from "./routes/snap";
import { neighborhoods } from "./neighborhoods";
import { moderation as routeModeration } from "./moderation";
import { fares, contributions } from "./fares";
import { events } from "./events";
import { pipeline } from "./pipeline";
import { scrapers } from "./scrapers";
import { logs } from "./logs";
import { live } from "./live";

export const api = {
  auth,
  dashboard,
  cities,
  agencies,
  users,
  stops,
  routes,
  routeSegments,
  snapPath,
  fares,
  events,
  contributions,
  pipeline,
  scrapers,
  logs,
  neighborhoods,
  auditLogs,
  live,
  moderation: {
    stopReviews: stopModeration.stopReviews,
    stopPictures: stopModeration.stopPictures,
    routeReviews: routeModeration.routeReviews,
  },
};
